import { MenuItem } from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';
import {
    UI_DASHBOARDS_PATH,
    UI_FUNCTIONAL_TESTING_PATH,
    UI_HAND_TEST_RESULTS_PATH,
    UI_AUTO_TEST_RESULTS_PATH,
    UI_TEST_RUN_PATH,
} from '@shared/constants/pathsConstants';

const SidebarMenuItem = ({ menuItem, currentLevel }) => {
    const { label, icon, link, testId } = menuItem;
    const location = useLocation();
    const isTestRunsItem = link === `/${UI_FUNCTIONAL_TESTING_PATH}/${UI_TEST_RUN_PATH}`;
    const isTestResultPage =
        location.pathname.startsWith(`/${UI_FUNCTIONAL_TESTING_PATH}/${UI_HAND_TEST_RESULTS_PATH}`) ||
        location.pathname.startsWith(`/${UI_FUNCTIONAL_TESTING_PATH}/${UI_AUTO_TEST_RESULTS_PATH}`);
    const isActive =
        (link === '/' ? location.pathname === '/' : location.pathname.startsWith(link)) ||
        (link.startsWith(`/${UI_DASHBOARDS_PATH}`) && location.pathname.startsWith(`/${UI_DASHBOARDS_PATH}`)) ||
        (isTestRunsItem && isTestResultPage);

    return (
        <MenuItem
            data-testid={testId}
            icon={icon}
            component={<Link to={link} />}
            active={isActive}
            style={{
                paddingLeft: currentLevel === 0 ? '8px' : `${currentLevel * 40}px`,
            }}
        >
            {label}
        </MenuItem>
    );
};

export default SidebarMenuItem;
